import xaf from '@baidu/antifraud-xaf3';
import {GetFkParamsArgs, FkParamsVal} from './index.d';
import {cookie4h5 as cookie, COOKIE_KEY} from '../util/cookie';



/**
 *
 * @description h5获取基础参数 jt 不依赖端能力 h5主要靠这个来防护
 * @return {Object}
 */
const getJt = ({getConf, baiduID}: {getConf: GetFkParamsArgs; baiduID: string}): Promise<string> => {
    return new Promise(resolve => {
        try {
            const extParams = {
                a: baiduID,
                aid: getConf.ak,
                biz: {
                    ev: getConf.ev,
                    baiduID
                },
                complete(res: {code: number; jt: string}) {
                    if (+res.code === 0) {
                        resolve(res.jt);
                    } else {
                        resolve('');
                    }
                }
            };

            xaf.report(extParams);
        } catch (error) {
            resolve('');
        }
    });
};

/**
 * 获取风控参数 (h5) 参考 http://wiki.baidu.com/pages/viewpage.action?pageId=357373756&preview=/357373756/1487995105/%E9%A3%8E%E6%8E%A7%20JS%20SDK%20%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97.pdf
 *
 * @param {Object} userConf 透传数据
 * userConf.aid 渠道号（安全实验室分配app key）
 * userConf.dataApp
 * userConf.ev 用户动作
 * @return {Object} Promise对象，获取风控参数
 */
export const getFkParamsAll = (userConf: GetFkParamsArgs): Promise<FkParamsVal> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
        try {
            const getConf = Object.assign(
                {
                    ev: 'page_enter',
                    ak: '6403',
                    dataApp: 'eyJhcHBfa2V5IjoiNjQwMyIsImFwcF92aWV3IjoicHJvbW90ZSIsImJyb3dzZXJfdXJsIjoiaHR0cHM6Ly9zb2ZpcmUuYmFpZHUuY29tL2RhdGEvdWEvYWIuanNvbiIsImZvcm1fZGVzYyI6IiIsInNlbmRfaW50ZXJ2YWwiOjUwLCJzZW5kX21ldGhvZCI6M30'
                },
                userConf
            );
            // pc端 app为universe
            const app = 'universe';
            // pc端 zid 为空
            const zid = '';
            xaf.init({
                aid: getConf.ak,
                dataApp: getConf.dataApp
            });
            const baiduID = cookie(COOKIE_KEY.BAIDUID);
            const jt = await getJt({getConf, baiduID});

            resolve({
                z: zid,
                jt,
                js_env: 'h5',
                app,
            });
        } catch (err) {
            console.error('getFkParamsAll 出错：', err);
            reject(err);
        }
    });
};
